var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ModalHeader"},[_c('h3',{staticClass:"ModalHeader__heading"},[_vm._t("default")],2),_vm._v(" "),_c('button-cta',{staticClass:"ModalHeader__close",attrs:{"type":"button","theme":"none","data-dismiss":"modal","aria-label":"Close","onClick":_vm.closeModal}},[_vm._v("×")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66b4a97a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal/modal-header.vue
// module id = null
// module chunks = 